
import auth from '@/plugins/firebase/auth'
import { useRouter } from 'vue-router'
import { useUser } from '@/mixins'
export default {
  setup(): unknown {
    const router = useRouter()
    const { currentUser } = useUser()
    const logout = async (): Promise<void> => {
      try {
        await auth.signOut()
        router.push({ name: 'SignIn' })
      } catch (error) {
        console.error(error)
      }
    }
    return {
      currentUser,
      logout
    }
  }
}
